import React from "react";
import { Card, Row } from "react-bootstrap";

export const ContentWrapperCard = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <Row className="justify-content-center">
      <div className="col-xs-12 col-md-12 col-lg-10 col-xxl-6">
        <Card>
          <Card.Body>{children}</Card.Body>
        </Card>
      </div>
    </Row>
  );
};
